import dayjs from 'dayjs'
import { graphql } from 'gatsby'
import React from 'react'
import Layout from '../components/layout'
import TextBlock from '../components/text-block'
import { classes } from '../utils/components'
import styles from './news-article.module.css'

export default ({ data: { article } }) => {
  return (
    <Layout
      seoMetaTags={article.seoMetaTags}
      title={article.seoSettings && article.seoSettings.title}
    >
      <article className={classes(styles.article)}>
        <header className="bg-brand-cyan">
          <div className="container flex flex-col justify-center h-full py-6 min-h-hero-mobile md:min-h-hero-default">
            {article.date && (
              <time className="mb-6 text-xl font-normal md:mb-12 text-secondary">
                {dayjs(article.date).format('MMMM DD, YYYY')}
              </time>
            )}
            <h1 className="text-4xl font-normal leading-tight md:text-6xl md:max-w-4xl">
              {article.headline}
            </h1>
            {article.subheading && (
              <h2 className="mt-4 text-2xl font-normal leading-tight md:mt-8 md:text-4xl md:max-w-4xl">
                {article.subheading}
              </h2>
            )}
          </div>
        </header>
        <section className="container py-8 md:py-16">
          <TextBlock text={article.contentNode} colorClass="text-primary" />
        </section>
      </article>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    article: datoCmsNewsArticle(slug: { eq: $slug }) {
      seoSettings {
        title
      }
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      headline
      subheading
      date
      contentNode {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`
